var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-footer"},[_c('div',[_c('span',[_vm._v("建议使用360浏览器极速模式，分辨率1400*900以上访问本网站")])])])}]

export { render, staticRenderFns }